export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_OVER_AGE = "SET_OVER_AGE";
export const SET_MENU_OPEN = "SET_MENU_OPEN";
export const SET_SLICE_OVERLAY = "SET_SLICE_OVERLAY";
export const SET_ACTIVE_SECTION = "SET_ACTIVE_SECTION";
export const SET_SCROLL_DIRECTION = "SET_SCROLL_DIRECTION";
export const SET_SCREEN_SIZE = "SET_SCREEN_SIZE";